export const useArrowToSpace = str => {
  return str?.length >= 1 && str?.replace(/-/g, " ")
}
